import sanitizeHtml from "sanitize-html"

import { isNullOrUndefined } from "$/utils/gates"
import { TranslationObj } from "$/utils/lang"

import { buildCssClassName } from "@/3514/utils"
import { ReflectionComponentType } from "@/constants"
import { AnswerOption } from "@/entities/pairing-question"
import { SurveyQuestionPreviosAnswer } from "@/entities/survey/models"
import { type TGetValueFromTranslatedObjectFunction, useGetValueFromTranslatedObject } from "@/hooks"
import { LikertColorType } from "@/models/types"
import { WarningMessage } from "@/shared/WarningMessage"

import { LikertRow } from "./NewLikertRow"

type Props = {
    className?: string
    rowClassName?: string
    questionNumber?: number
    item: AnswerOption
    question: TranslationObj
    register: any
    control: any
    errors: any
    error?: any
    name?: string
    color?: LikertColorType
    previousAnswer?: SurveyQuestionPreviosAnswer
    likertType?: ReflectionComponentType.LIKERT_GROUP | ReflectionComponentType.COLORED_LIKERT_GROUP
    showOddLabels?: boolean
    headerTextClassName?: string
    questionStyle?: "one-line" | "brand"
}

export const LikertComponent = ({
    className,
    questionNumber,
    rowClassName,
    item,
    register,
    control,
    errors,
    error,
    question,
    previousAnswer,
    color = "gray",
    name,
    questionStyle = "brand",
    headerTextClassName,
    showOddLabels = false,
    likertType
}: Props) => {
    const isDefaultLikert =
        item.component_type === ReflectionComponentType.LIKERT_GROUP ||
        likertType === ReflectionComponentType.LIKERT_GROUP
    const likertColorType = isDefaultLikert ? color : "colored"
    const likertComponentType = isDefaultLikert
        ? ReflectionComponentType.LIKERT_GROUP
        : ReflectionComponentType.COLORED_LIKERT_GROUP

    const showQuestionNumber =
        !isNullOrUndefined(questionNumber) || (typeof questionNumber === "number" && questionNumber > 0)

    const getValueFromTranslatedObject: TGetValueFromTranslatedObjectFunction = useGetValueFromTranslatedObject()

    return (
        <div className={className}>
            {questionStyle === "brand" ? (
                <>
                    {showQuestionNumber && (
                        <h4 className="h5 color-brand text-uppercase font-extrabold title-underline mb-3">
                            <span>{questionNumber}</span>
                        </h4>
                    )}
                    <div
                        className="text-container--sm mb-[40px] text-center"
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(getValueFromTranslatedObject(question), { allowedTags: [] })
                        }}
                    />
                </>
            ) : (
                <p className={buildCssClassName("d-flex mb-[20px]", headerTextClassName)}>
                    {showQuestionNumber && <span className="font-extrabold mr-2">{questionNumber}.</span>}
                    <span
                        className="d-inline"
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(getValueFromTranslatedObject(question), { allowedTags: [] })
                        }}
                    />
                </p>
            )}

            <LikertRow
                name={name}
                control={control}
                previosAnswer={previousAnswer}
                register={register}
                options={item?.options}
                likertColorType={likertColorType}
                className={rowClassName}
                likertType={likertComponentType}
                showOddLabels={showOddLabels}
            />
            <WarningMessage message={error ?? errors?.[name]?.message?.toString()} />
        </div>
    )
}
